import { Chip, Tooltip } from "@mui/material";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import { absoluteTime, relativeFromNow } from "../CommentsPanel/time";
import { reviewTokens } from "../../theme";

interface Props {
  expiresAt: string | Date | null | undefined;
  testId?: string;
}

const EXPIRING_SOON_THRESHOLD_MS = 7 * 24 * 60 * 60 * 1000;

export function ExpiryChip({ expiresAt, testId }: Props) {
  if (!expiresAt) return null;
  const ms = new Date(expiresAt as string).getTime();
  if (Number.isNaN(ms)) return null;

  const diffMs = ms - Date.now();
  const expired = diffMs <= 0;
  const expiringSoon = !expired && diffMs <= EXPIRING_SOON_THRESHOLD_MS;
  const relative = relativeFromNow(expiresAt);
  const absolute = absoluteTime(expiresAt);

  const colors = expired
    ? {
        bg: "rgba(220, 38, 38, 0.08)",
        fg: "#B91C1C",
        border: "rgba(220, 38, 38, 0.18)",
      }
    : expiringSoon
    ? {
        bg: "rgba(245, 158, 11, 0.10)",
        fg: "#B45309",
        border: "rgba(245, 158, 11, 0.22)",
      }
    : {
        bg: reviewTokens.slate50,
        fg: reviewTokens.slate600,
        border: reviewTokens.border,
      };

  return (
    <Tooltip title={`${expired ? "Expired on" : "Expires on"} ${absolute}`}>
      <Chip
        size="small"
        icon={
          <AccessTimeRoundedIcon
            sx={{ fontSize: 11, color: `${colors.fg} !important` }}
          />
        }
        label={expired ? `Expired ${relative}` : `Expires ${relative}`}
        sx={{
          height: 18,
          fontSize: 10,
          fontWeight: 600,
          bgcolor: colors.bg,
          color: colors.fg,
          border: `1px solid ${colors.border}`,
          "& .MuiChip-icon": { ml: "4px", mr: "-2px" },
          "& .MuiChip-label": { px: 0.75 },
        }}
        data-testid={testId}
      />
    </Tooltip>
  );
}
